import MaritalStatusIcon from "../../assets/marital_status_icon.png";
import LocationIcon from "../../assets/location.png";
import NationalityIcon from "../../assets/nationality_icon.png";
import AgeIcon from "../../assets/age_icon.png";
import GenderIcon from "../../assets/gender_icon.png";
import Placeholder from "../../assets/image_placeholder.png";
import "../../styles/profile_details.css";
import moment from "moment";

const Details = ({ carepro, imageUrl }) => {
    const getAgeByDob = () => {
        const dob = moment(carepro?.dob).format("yyyy");
        const nowYear = moment(moment.now()).format("yyyy");
        return nowYear-dob;
    }
    return (
        <div>
            <div className="profile-container" >
                <div className="column profile-image-container">
                    <img className={imageUrl? "image" : "placeholder"} alt={`${carepro.name}`} src= { imageUrl || Placeholder } />
                </div>
                <div className="column name-container">
                    <div className="profile-details-container profile-detials-font">
                        <div className="row name">
                            {carepro.name? `${carepro.name}` : "-"}
                        </div>
                        <div className="row type">
                            {carepro.profession_type? `${carepro.profession_type}` : "-"}
                        </div>
                        <div className="row address">
                            <img src={ LocationIcon } alt="Address" className="location"/>
                            {carepro.state? `${carepro.state}` : "-"}
                        </div>
                    </div>
                </div>
            </div>

            <div className="profile2-container">
                <div className="column details-container">
                    <img className="icon" alt="Nationality" src={ NationalityIcon } />
                    <div className="icon-details-container">
                        {/* <span className="icon-header">Nationality</span> */}
                        <span className="icon-text">{carepro.nationality? `${carepro.nationality}` : "-"}</span>
                    </div>
                </div>

                <div className="column details-container">
                    <img className="icon" alt="Marital Status" src={ MaritalStatusIcon } />
                    <div className="icon-details-container">
                        {/* <span className="icon-header">Marital Status</span> */}
                        <span className="icon-text">{carepro.marital_status? `${carepro.marital_status}` : "-"}</span>
                    </div>
                </div>

                <div className="column details-container">
                    <img className="icon" alt="Age" src={ AgeIcon } />
                    <div className="icon-details-container">
                        {/* <span className="icon-header">Age</span> */}
                        <span className="icon-text">{carepro.dob? `${getAgeByDob()}` : "-"}</span>
                    </div>
                </div>

                <div className="column details-container">
                    <img className="icon" alt="Gender" src={ GenderIcon } />
                    <div className="icon-details-container">
                        {/* <span className="icon-header">Gender</span> */}
                        <span className="icon-text">{carepro.sex? `${carepro.sex}` : "-"}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Details;